import { default_get, default_post } from "../default";

export function getPaasPlans() {
    return default_get('/paas/plan/all')
}

export function getPaasPlanSolution(_id) {
    return default_get(`/paas/plan/solution?id=${_id}`)
}

export function thereArePlansInQueue() {
    return default_get('/paas/plan/thereArePlansInQueue')
}

export function updatePlan(_plan) {
    return default_post({..._plan}, '/paas/plan/update')
}

export function deletePlan(_plan) {
    return default_post({..._plan}, '/paas/plan/delete')
}

export function toggleShare(id) {
    return default_post({ id }, '/paas/plan/toggleShare' )
}

export function findSharedPlan(hash) {
    return default_post({ hash }, '/paas/plan/shared' )
}

export function editSolutionPlan(_plan, classes, rooms) {
    return default_post({ id: _plan, classes, rooms }, '/paas/plan/editSolution' )
}

export function restoreSolutionPlan(id, plan) {
    return default_post({ id, plan }, '/paas/plan/restore' )
}